import React from 'react';
import { AnyEventHandler } from '../../workbook/types';
import './Header.scss';

interface HeaderProps {
 enableLogin?:boolean
 showWaitlist?:AnyEventHandler
 dashboard?:any
}
interface HeaderState {
 menuActive:boolean
 quotaTier: number
}
class Header extends React.Component<HeaderProps, HeaderState> {
  constructor(props:HeaderProps) {
    super(props);
    this.state = { menuActive: false, quotaTier: 0 };
  }

  render() {
  return <><nav className="navbar is-transparent" role="navigation" aria-label="main navigation">
  <div className="navbar-brand">
    <a className="navbar-item" href="/index.html">
      <img className="s-logo" src="/img/wordmark.png" style={{ width: "15rem", maxHeight: "unset" }} />
    </a>

    <a role="button" className={`navbar-burger burger ${this.state.menuActive && 'is-active'}`} aria-label="menu" aria-expanded="false" data-target="navbarBasicExample"
        onClick={() => this.setState({ menuActive: !this.state.menuActive })}>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
    </a>
  </div>

  <div className={`navbar-menu ${this.state.menuActive && 'is-active'}`}>
    <div className="navbar-start"></div>
    <div className="navbar-end">
      <div className="navbar-item">
        <a className="button" href="/faq.html">FAQ</a>
      </div>
      <div className="navbar-item has-dropdown is-hoverable">
        <a className="navbar-link button" href="#">Docs</a>

          <div className="navbar-dropdown">
            <hr className="navbar-divider" />
            <a className="navbar-item" target="_blank"  href="/apiDocs.html">
              API Docs
            </a>
            <a className="navbar-item" target="_blank"  href="/formulas">
              Formula Docs
            </a>
          </div>
      </div>
      <div className="navbar-item">
        <div className="buttons">
          {(() => {
          if(this.props.enableLogin) {
            if(this.props.dashboard) {
              return <a className="button" href="/logout">
              <strong>Sign out</strong></a>;
          } else {
            return <a className="button s-cta" href="/login">
            <strong>Sign in</strong></a>;
          }  
          } else {
            return <a className="button s-cta" href="https://learn.sheet.rocks/launch-list/">Join waitlist</a>; 
          }})()}
        </div>
      </div>
    </div>
  </div>
</nav>
</>
}
}

export default Header;
